import type { InjectionKey, Ref } from 'vue'

export const registerBlockInjectionKey = Symbol() as InjectionKey<
  (uid: number, height: Ref<number>) => void | undefined
>

export const deregisterBlockInjectionKey = Symbol() as InjectionKey<
  (uid: number) => void | undefined
>
